<template>
  <div class="page">
    <div class="bg_color">
      <section class="main">
        <h1 class="font_size_30 text_center title_color">师资介绍</h1>
        <br />
        <h2 class="text_center text_left text_indent">
          创远生涯研究院是由企业管理精英、资深教育学者及心理医学专家联合发起成立的专业机构，专注于个体生涯规划领域的学术研究与课程体系研发。机构秉持 “以人为本、以终为始”
          的核心理念，致力于通过系统性的规划方法论，助力个体深化自我认知、激活天赋潜能，实现从认知升级到价值成就的全维度发展。
        </h2>
        <el-row v-for="(item, index) in teamList" :key="index">
          <el-col :span="24">
            <div class="card">
              <div class="card_avatar">
                <img :src="item.url" alt="" style="width: 38%" />
              </div>
              <div class="content">
                <h4 class="title_color font_size_20">{{ item.name }}</h4>
                <!-- <p class="title_color">{{ item.title }}</p> -->
                <!-- <p>{{ item.content }}</p> -->
                <p class="article" v-html="item.remarks"></p>
              </div>
            </div>
          </el-col>
        </el-row>
      </section>
    </div>
  </div>
</template>

<script>
  import img1 from "../../assets/image/team/宋臻.jpg";
  import img2 from "../../assets/image/team/魏徽.jpg";
  import img3 from "../../assets/image/team/季卫东.jpg";
  import img4 from "../../assets/image/team/张小琴.jpg";
  import img5 from "../../assets/image/team/王敏.jpg";
  export default {
    name: "Team",
    data() {
      return {
        teamList: [
          {
            url: img1,
            name: "宋臻",
            title: "创远生涯研究院 院长",
            content: "生涯规划导师，一级人力资源管理师，一级培训师",
            remarks: '创远生涯研究院院长，拥有生涯规划导师、一级人力资源管理师、一级培训师等专业资质。作为人才梯队培养讲师，宋老师在就业及职业规划领域积累深厚，对企业人才的选、育、用、留具备丰富实战经验。长期投身于学业及职业规划教育公益活动、就业促进中心公益讲座，通过大学巡讲为近千名学员提供学业及职业规划辅导，同时以大赛评委身份一对一指导近百名学生提升升学及就业质量，助力众多学员实现晋升发展与转型突破。'
          },
          {
            url: img2,
            name: "魏徽",
            title: "创远生涯研究院 副院长",
            content:
              "生涯规划导师，家庭教育指导师，国家二级心理咨询师，小立教育华东区负责人",
            remarks:
              "创远生涯研究院副院长，具备生涯规划导师、家庭教育指导师、国家二级心理咨询师等专业资质，现任小立教育华东区负责人。深耕教育领域 15 年以上，拥有丰富实践经验，担任上海多家私立幼儿园家庭教育指导顾问、上海市教委人文素质培养特聘讲师及大学校园大使，累计服务超万组家庭。长期专注青少年生涯规划，针对孩子内驱力激活独创教学体系，尤其擅长新高考背景下的升学指导，以及高效改善 “青春期” 亲子关系、解决叛逆问题，实战案例丰富且成效显著。",
          },

          {
            url: img3,
            name: "季卫东",
            title: "创远生涯研究院 专家顾问",
            content: "",
            remarks:
              "现任创远生涯研究院专家顾问，医学博士，教授，硕士生导师。作为中国心理学会注册督导师及认证叙事家庭治疗师，他在心理治疗领域具有深厚的学术造诣与实践经验。季教授同时担任中国康复医学会康复心理学专业委员会副主任委员，并领衔上海市心理学会医学心理学专业委员会主任委员职务，在心理康复与医学心理学领域持续推动学科发展及专业人才培养。其复合型专家背景涵盖高等教育、临床督导与行业组织管理等多重维度。",
          },

          {
            url: img4,
            name: "张小琴",
            title: "创远生涯研究院 高级研究员",
            content: "",
            remarks:
              "创远生涯研究院高级研究员，具备生涯规划咨询师、企业培训师、DISC 认证培训师专业资质，持有中科院心理咨询师培训证书。深耕企业人力资源管理及人才教育发展领域多年，积累了丰富的实战经验，长期专注于家庭教育与青少年生涯规划的探索研究。擅长将企业人才培养体系与个体成长规律相结合，以 DISC 行为测评等科学工具为依托，针对青少年身心发展特点设计个性化生涯规划方案，助力其构建清晰的自我认知与发展路径。作为 “以人为本、以终为始” 规划理念的践行者。",
          },
          {
            url: img5,
            name: "王敏",
            title: "创远生涯研究院 资深研究员",
            content: "生涯规划咨询师，家庭教育指导者",
            remarks:
              "创远生涯研究院资深研究员，具备生涯规划咨询师、家庭教育指导者专业身份。专注于家庭教育与青少年生涯规划领域，凭借扎实的专业基础，累计协助导师服务超 100 个家庭，深度参与个体成长规划与家庭养育支持工作。作为 “以人为本、以终为始” 规划理念的践行者，她注重从家庭生态与青少年个体发展需求出发，通过个性化沟通与方案设计，帮助家庭建立科学的教育认知，助力青少年明确自我定位与成长方向，推动生涯规划理论在家庭场景中的实践落地。",
          },
        ],
      };
    },
    created() { },
    methods: {},
  };
</script>
<style lang="less" scoped>
  .page {
    color: #333333;
  }

  .title_color {
    color: #fd4a29;
  }

  .text_indent {
    text-indent: 2em;
  }

  .text_center {
    text-align: center;
  }

  .text_left {
    text-align: left;
  }

  .font_size_18 {
    font-size: 18px;
  }

  .font_size_20 {
    font-size: 20px;
  }

  .font_size_30 {
    font-size: 30px;
  }

  .section {
    margin: 50px 15%;
  }

  .article {
    line-height: 30px;
  }

  .card {
    background-color: #fff;
    border-radius: 18px;
    margin: 20px 0;

    .content {
      padding: 10px;

      p {
        margin: 8px 0;
      }
    }
  }

  .card_avatar {
    text-align: center;
    padding-top: 10px;

    img {
      border-radius: 18px;
    }
  }

  .el-row {
    margin: 40px 0;
  }

  .bg_color {
    background-color: #fef4eb;
  }

  .main {
    padding: 20px;
  }
</style>